import { Button } from '@/components/ui/button'
import { MessageCircle } from 'lucide-react'

export const FinalCTASection = () => {
  const whatsappUrl =
    'https://wa.me/5511963087549?text=Quero%20saber%20mais%20sobre%20o%20SuperFut%20Kids'

  return (
    <section className="py-24 bg-super-text relative overflow-hidden">
      {/* Background patterns */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
        <div className="absolute top-10 left-10 w-32 h-32 rounded-full border-4 border-white/20" />
        <div className="absolute bottom-10 right-10 w-48 h-48 rounded-full bg-white/10 blur-3xl" />
      </div>

      <div className="container px-4 md:px-6 mx-auto relative z-10 text-center">
        <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-6">
          Pronto para dar o primeiro chute?
        </h2>
        <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto mb-10">
          Fale com a gente e receba uma recomendação de turma/formatos para a
          idade do seu filho.
        </p>
        <Button
          size="lg"
          className="bg-super-yellow text-super-text hover:bg-yellow-400 font-bold text-lg px-10 rounded-full shadow-glow transition-transform hover:scale-105"
          asChild
        >
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
            <MessageCircle className="w-6 h-6 mr-2" />
            Quero saber mais
          </a>
        </Button>
      </div>
    </section>
  )
}
